import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { OrganisationToneModel } from "../models/OrganisationModels";
import { ToastContext } from "../context/ToastContext";
import { useSWRFetcher } from "./useSWRFetcher";

export const useOrganisationTones = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<OrganisationToneModel[]>(
    `${environment.apiUrl}/api/organisation/tones`,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get tones, please try again later", "error");
      },
    }
  );

  return {
    tones: data,
    isLoading,
    isError: !!error,
  };
};
